export default __webpack_public_path__ + "static/media/Github-Normal.b7cb1438.png";